import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12.1 2C9.55949 2 7.5 4.05949 7.5 6.6C7.5 9.14051 9.55949 11.2 12.1 11.2C14.6405 11.2 16.7 9.14051 16.7 6.6C16.7 4.05949 14.6405 2 12.1 2ZM12.1 4C13.5359 4 14.7 5.16406 14.7 6.6C14.7 8.03594 13.5359 9.2 12.1 9.2C10.6641 9.2 9.5 8.03594 9.5 6.6C9.5 5.16406 10.6641 4 12.1 4ZM21.2 21C21.2 15.9742 17.1258 11.9 12.1 11.9C7.07421 11.9 3 15.9742 3 21C3 21.5523 3.44772 22 4 22C4.55228 22 5 21.5523 5 21C5 17.0788 8.17878 13.9 12.1 13.9C16.0212 13.9 19.2 17.0788 19.2 21C19.2 21.5523 19.6477 22 20.2 22C20.7523 22 21.2 21.5523 21.2 21Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'PersonOutline');

export default Icon;
